import React, {Component} from 'react';
import PropTypes from 'prop-types';
import translate from '../service/translation';

export default class LoadMoreButton extends Component {

    static propTypes = {
        handleLoadMoreClick: PropTypes.func.isRequired,
        isLoading : PropTypes.bool,
        EXTKEY: PropTypes.string
    };

    render() {
        const {handleLoadMoreClick, isLoading, EXTKEY} = this.props;

        return (

            <div className={EXTKEY + '__wrapper--navigation ' + EXTKEY + '__load-more--navigation'}>
                {isLoading ?
                    translate('list_pagination_loading') :
                    <button onClick={handleLoadMoreClick}
                            className={EXTKEY + '__button ' + EXTKEY + '__button--load-more btn btn-primary'}>
                        <span className={EXTKEY + '__button--icon ' + EXTKEY + '__icon--load-more'}/>
                        {translate('list_pagination_load_more')}
                    </button>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./React/src/components/LoadMoreButton.js